// extracted by mini-css-extract-plugin
module.exports = {"BreadCrumbs":"BreadCrumbs_BreadCrumbs__2xbLB"};